<div class="page-container">
  <app-loader *ngIf="!stack"></app-loader>

  <div *ngIf="stack && stack.length !== 0" class="progress-header">
    <div class="progress-grid">
      <span>{{learnset?.name}}</span>
      <div class="progress-badge">
        <i-tabler name="circle-check"></i-tabler>
        <span>{{totalCount - stack!.length}}/{{totalCount}}</span>
      </div>
    </div>
    <app-progress-bar [progress]="100 - (stack!.length / totalCount) * 100"></app-progress-bar>
  </div>

  <ng-container *ngIf="stack && stack.length > 0">
    <div class="card" (click)="changeSide()">
      <div class="card-content-wrapper">
        <div class="card-content">
          <app-loader *ngIf="isLoading"></app-loader>
          <div *ngIf="!isLoading" class="front-wrapper" [innerHtml]="stack[0].question"></div>
          <div *ngIf="!isLoading" class="divider"></div>
          <div [class.hidden]="isLoading || side !== 'back'" class="back-wrapper" [innerHtml]="stack[0].answer"></div>
          <div *ngIf="side === 'back'" class="card-footer">
            <button *ngIf="!isLoadingExplanation" class="explanation-button" (click)="showExplanation(); $event.stopPropagation()">
              <i-tabler name="sparkles"></i-tabler>Ausführliche KI-Erklärung
            </button>
            <app-loader *ngIf="isLoadingExplanation" [text]="'Erklärung wird geladen...'"></app-loader>
          </div>
          <div *ngIf="!isLoading && side === 'front'" class="click-notice">
            <i-tabler name="hand-click"></i-tabler>
            Antwort ansehen
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="smartRepetitionEnabled" [class.hidden]="side === 'front'" class="feedback-container">
      <div class="sm2-feedback">
        <button class="button" (click)="next(0)" [disabled]="sm2ButtonsDisabled && currentLoadingScoreButton !== 0">
          <span class="icon">😵</span>
          <span class="text">Vergessen</span>
        </button>
        <button class="button" (click)="next(3)" [disabled]="sm2ButtonsDisabled && currentLoadingScoreButton !== 3">
          <span class="icon">🫣</span>
          <span class="text">Schwierig</span>
        </button>
        <button class="button" (click)="next(4)" [disabled]="sm2ButtonsDisabled && currentLoadingScoreButton !== 4">
          <span class="icon">🙂</span>
          <span class="text">Gut</span>
        </button>
        <button class="button" (click)="next(5)" [disabled]="sm2ButtonsDisabled && currentLoadingScoreButton !== 5">
          <span class="icon">😎</span>
          <span class="text">Perfekt</span>
        </button>
      </div>
    </div>

    <div *ngIf="!smartRepetitionEnabled" [class.hidden]="side === 'front'" class="feedback-container">
      <div class="sm2-feedback">
        <div></div>
        <div></div>
        <div></div>
        <button class="button" (click)="next(5)" [disabled]="sm2ButtonsDisabled && currentLoadingScoreButton !== 5">
          <i-tabler name="arrow-right"></i-tabler>
          <span class="text">Nächste Karte</span>
        </button>
      </div>
    </div>
  </ng-container>

  <app-learn-success-view *ngIf="stack && stack.length === 0" [currentCardsLearned]="totalCount" [learnsetHasMoreCards]="learnsetHasMoreCards" (continueSession)="continueSession()" (finishSession)="finishSession()"></app-learn-success-view>

  <app-bottom-dialog [isVisible]="explanationVisible" [title]="'KI-Erklärung'" [iconName]="'sparkles'" (actionCancelled)="explanationVisible = false">
    <div class="explanation-wrapper" [innerHTML]="currentExplanation"></div>
  </app-bottom-dialog>

  <app-bottom-dialog [isVisible]="introductionVisible" [title]="'Einführung'" [iconName]="'info-circle'" (actionCancelled)="introFinished()">
    <div class="introduction-wrapper">
      <app-learn-intro (finished)="introFinished()"></app-learn-intro>
    </div>
  </app-bottom-dialog>

  <app-bottom-dialog [isVisible]="premiumPromptVisible" [title]="'Sparkly-Premium'" [iconName]="'diamond'" (actionCancelled)="premiumPopupCancelled()">
    <div class="premium-benefits-wrapper">
      <h2>Lerne noch smarter mit Sparkly Premium</h2>
      <div class="benefits-list">
        <div *ngFor="let benefit of benefits" class="list-item">
          <i-tabler [name]="benefit.icon"></i-tabler>
          <div>
            <span class="title">{{benefit.title}}</span>
            <span class="description">{{benefit.description}}</span>
          </div>
        </div>
      </div>
      <div class="wrapper-footer">
        <span>Ab <b>1,99 €</b> pro Monat</span>
        <app-button [text]="'Alle Vorteile entdecken'" (clickEvent)="navToGetPremium()"></app-button>
      </div>
    </div>
  </app-bottom-dialog>
</div>